import RankFourteen from '@assets/icons/rank-fourteen.svg'
import { Icon } from './Icon'

export const RankFourteenIcon = Icon(RankFourteen)
